import * as React from 'react'
import { Link } from 'react-router-dom'

import {
  Footer,
  FooterItem
} from '@espoon-voltti/react-components/components/footer'
import { t } from '../i18n'

export const AppFooter = () => (
  <Footer dataQa={'footer'}>
    <FooterItem>© {t(['footer', 'cityOfEspoo'])}</FooterItem>
    <FooterItem dataQa={'dataPrivacy'}>
      <a
        href="https://www.espoo.fi/fi/kaupunki-ja-paatoksenteko/tietosuojaselosteet/kasvun-ja-oppimisen-toimialan-tietosuojaselosteet/tietosuojaseloste-avustushakemusten-kasittely-ja-arkistointi-nuorisopalveluissa"
        target="blank"
      >
        {t(['footer', 'privacyPolicy'])}
      </a>
    </FooterItem>
    <FooterItem dataQa={'accessibility'}>
      <Link to={'/accessibility'}>{t(['footer', 'a11yStatement'])}</Link>
    </FooterItem>
    <FooterItem dataQa={'feedback'}>
      <a
        href="https://easiointi.espoo.fi/eFeedback/fi/Feedback/20-S%C3%A4hk%C3%B6iset%20asiointipalvelut"
        target="blank"
      >
        {t(['footer', 'feedback'])}
      </a>
    </FooterItem>
  </Footer>
)
